<template>

    <Head title="Relatórios" />

    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
        <p class="title"><strong>Pesquisa</strong></p>
        <form class="mt-1 w-full" @submit.prevent="reloadTable">
            <div class="grid grid-cols-10 gap-4 px-4 mb-6">
                <date-input v-model="filters.ProviderReport.date"
                    class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2" label="Data do relatório" />

                <multi-select-input v-model="filters.ProviderReport.market_network" :multiple="true"
                    :options="options.marketNetworkSearch" class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2"
                    label="Rede" />

                <multi-select-input v-model="filters.ProviderReport.market" :multiple="true"
                    :options="options.marketSearch" class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2"
                    label="Número da loja" />

                <multi-select-input v-model="filters.ProviderReport.brand" :multiple="true"
                    :options="options.brandSearch" class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2"
                    label="Marca" />

                <multi-select-input v-model="filters.ProviderReport.product" :multiple="true"
                    :options="options.productSearch" class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2"
                    label="Produto" />

                <multi-select-input v-model="filters.ProviderReport.sales_promoter" :multiple="true"
                    :options="options.salesPromoterSearch" class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2"
                    label="Promotor" />
            </div>
            <div class="flex flex-shrink-0 flex-wrap items-center justify-end gap-3 rounded-b-md p-4">
                <button
                    class="btn-purple px-6 py-2.5 text-xs font-medium uppercase leading-tight text-white transition duration-150 ease-in-out rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg">
                    <font-awesome-icon icon="fa-magnifying-glass" class="text-sm text-white mr-0 lg:mr-2" />
                    Pesquisar
                </button>

                <button type="button"
                    class="btn flex items-center border-2 border-purple-100 px-6 py-2.5 text-xs font-medium uppercase text-purple-100"
                    @click="clearSearch">
                    <font-awesome-icon icon="fa-eraser" class="text-sm text-purple mr-0 lg:mr-2" />
                    Limpar
                </button>
            </div>
        </form>
    </div>

    <div class="shadow_box mt-4 rounded-lg p-6">
        <h1 class="mb-6 font-roboto text-2xl uppercase text-gray-777">
            <span class="overflow-hidden whitespace-nowrap">Relatórios de roteiros</span>
        </h1>
        <data-table ref="reportTable" v-model:columns="colunsProviderReport"
            no-data-label="Nenhuma atividade cadastrada" no-result-label="Nenhuma atividade encontrada"
            :route="'/provider/report/list'" :query="getQuery">
            <template #table.cell.content.actions="{ row }">
                <div class="inline-grid gap-4">
                    <button class="btn-purple inline-flex items-center justify-center px-6 py-2.5 text-xs font-medium"
                        @click="openReport(row)">
                        Acessar relatório
                        <font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                    </button>
                </div>
            </template>
        </data-table>
    </div>

    <Modal ref="detailModal" size="modal-xl" :modal-scrollable="true">
        <template #header>
            <div class="flex w-full items-start justify-between gap-4">
                <div class="max-w-lg">
                    <h2 class="text-2xl text-gray-500">Relatório de atividades</h2>
                    <!-- <p v-if="selectedReport && selectedReport.marketNetworkName" class="mt-1 text-sm text-gray-400">
                        {{ selectedReport.marketNetworkName }}
                    </p> -->
                </div>
                <button type="button" class="text-gray-400 hover:text-gray-600" @click="closeReport">
                    <font-awesome-icon icon="fa-solid fa-xmark" class="text-xl" />
                </button>
            </div>
        </template>

        <template #body>
            <div v-if="selectedReport" class="space-y-12 text-[#5B5B70]">
                <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Mercado</span>
                        <span class="block text-xs text-gray-400">
                            {{ selectedReport.marketNetworkName || '-' }}
                        </span>
                    </div>
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Fornecedor</span>
                        <span class="block text-xs text-gray-400">
                            {{ selectedReport.providerName || '-' }}
                        </span>
                    </div>
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Data</span>
                        <span class="block text-xs text-gray-400">
                            {{ formatDateTime(selectedReport.date) }}
                        </span>
                    </div>
                </div>

                <div class="flex flex-col gap-4">
                    <h3 class="text-xs text-gray-700">Gerenciamento de
                        atividades</h3>
                    <button type="button"
                        class="btn-purple w-fit inline-flex items-center gap-3 rounded-lg px-7 py-3 text-xs uppercase shadow-md transition hover:shadow-lg"
                        :disabled="!pdfUrl" :class="{ 'opacity-60 cursor-not-allowed': !pdfUrl }" @click="downloadPdf">
                        <font-awesome-icon icon="fa-regular fa-file" class="text-base" />
                        Emitir PDF
                    </button>
                </div>

                <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Status</span>
                        <span class="block text-xs text-gray-400">
                            {{ selectedReport.statusLabel || '-' }}
                        </span>
                    </div>
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Ruptura</span>
                        <span class="block text-xs text-gray-400">
                            {{ formatYesNo(selectedReport.nostock) }}
                        </span>
                    </div>
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Marca</span>
                        <span class="block text-xs text-gray-400">
                            {{ selectedReport.brandName || '-' }}
                        </span>
                    </div>
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Produtos</span>
                        <span class="block text-xs text-gray-400">
                            {{ formattedProducts }}
                        </span>
                    </div>
                    <div class="space-y-1">
                        <span class="text-xs text-gray-700">Data</span>
                        <span class="block text-xs text-gray-400">
                            {{ formatDateTime(selectedReport.date) }}
                        </span>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-10 lg:grid-cols-2">
                    <div class="space-y-5">
                        <div
                            class="relative flex h-72 items-center justify-center overflow-hidden rounded-3xl border border-gray-200 bg-[#F7F7FB]">
                            <template v-if="hasPhotos">
                                <img :src="currentPhoto" alt="Foto do relatório" class="h-full w-full object-contain" />

                                <button type="button"
                                    class="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-[#6266EA] shadow-sm transition hover:bg-white"
                                    @click="prevPhoto">
                                    <font-awesome-icon icon="fa-solid fa-chevron-left" />
                                </button>
                                <button type="button"
                                    class="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-[#6266EA] shadow-sm transition hover:bg-white"
                                    @click="nextPhoto">
                                    <font-awesome-icon icon="fa-solid fa-chevron-right" />
                                </button>

                                <button type="button"
                                    class="absolute right-4 top-4 rounded-full bg-white/80 p-2 text-[#6266EA] shadow-sm transition hover:bg-white"
                                    @click="openPhotoInNewTab(currentPhoto)">
                                    <font-awesome-icon icon="fa-solid fa-up-right-from-square" />
                                </button>
                            </template>
                            <div v-else class="text-sm text-gray-400">Nenhuma foto disponível</div>
                        </div>

                        <div v-if="hasPhotos" class="flex items-center justify-center gap-3">
                            <button v-for="(photo, index) in selectedReport.photos" :key="index" type="button"
                                class="h-2 rounded-full transition-all"
                                :class="{ 'w-10 bg-[#6266EA]': index === activePhotoIndex, 'w-3 bg-gray-300': index !== activePhotoIndex }"
                                @click="selectPhoto(index)"></button>
                        </div>
                    </div>

                    <div class="space-y-8">
                        <section class="space-y-2">
                            <h4 class="text-xs font-medium text-gray-700">Observação:</h4>
                            <p class="whitespace-pre-line text-xs leading-relaxed text-gray-500">
                                {{ observationText }}
                            </p>
                        </section>

                        <section class="space-y-2">
                            <h4 class="text-xs font-medium text-gray-700">Avaliação</h4>
                            <div class="flex items-center gap-2">
                                <button v-for="star in ratingStars" :key="star" type="button" :disabled="isSavingRating"
                                    :class="[
                                        'text-2xl transition-colors',
                                        isSavingRating ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
                                        star <= detailRating ? 'text-[#FFC857]' : 'text-gray-300'
                                    ]" @click="setRating(star)">
                                    <font-awesome-icon
                                        :icon="star <= detailRating ? 'fa-solid fa-star' : 'fa-regular fa-star'" />
                                </button>
                            </div>
                        </section>

                        <section class="space-y-4">
                            <div class="space-y-2">
                                <h4 class="text-xs font-medium text-gray-700">Comentários</h4>
                                <ul v-if="detailComments.length" class="space-y-2">
                                    <li v-for="(comment, index) in detailComments" :key="index"
                                        class="rounded-[18px] bg-[#F7F7FB] p-4 text-sm text-gray-600">
                                        <p class="whitespace-pre-wrap">{{ comment.message }}</p>
                                        <span class="mt-1 block text-xs text-gray-400">
                                            <template v-if="comment.author">
                                                {{ comment.author }} •
                                            </template>
                                            {{ formatDateTime(comment.createdAt) }}
                                        </span>
                                    </li>
                                </ul>
                                <p v-else class="text-xs text-gray-400">Nenhum comentário até o momento.</p>
                            </div>

                            <form class="space-y-3" @submit.prevent="submitComment">
                                <div class="flex gap-2 justify-center">
                                    <textarea v-model="detailComment" rows="1" placeholder="Adicionar comentário"
                                        :disabled="isSubmittingComment"
                                        class="w-full rounded-2xl border border-gray-200 bg-[#F7F7FB] p-4 text-sm text-gray-600 shadow-sm focus:border-purple focus:outline-none focus:ring-2 focus:ring-purple/20 disabled:opacity-60 disabled:cursor-not-allowed"></textarea>
                                    <button type="submit" :disabled="!canSubmitComment" :class="[
                                        'btn-purple inline-flex items-center gap-2 rounded-lg px-6 py-2 text-xs uppercase transition',
                                        !canSubmitComment ? 'opacity-60 cursor-not-allowed' : ''
                                    ]">
                                        Enviar
                                        <font-awesome-icon icon="fa-solid fa-paper-plane" />
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </div>
            <div v-else class="py-10 text-center text-sm text-gray-400">
                Nenhum relatório selecionado.
            </div>
        </template>
    </Modal>

</template>

<script>
import axios from 'axios'
import { Head } from '@inertiajs/inertia-vue3'

import ProviderLayout from '@/Shared/ProviderLayout'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import DateInput from '@/Shared/DateInput'
import DataTable from '@/Shared/DataTable'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'

import Modal from '@/Shared/Modal'

import { colunsProviderReport } from './tableColumns'

export default {

    components: {
        Head,
        MultiSelectInput,
        DateInput,
        DataTable,
        Modal,
    },

    layout: ProviderLayout,

    mixins: [
        getFiltersMixin,
    ],

    data() {
        return {
            options: {
                marketNetworkSearch: [],
                marketSearch: [],
                providerSearch: [],
                brandSearch: [],
                productSearch: [],
                salesPromoterSearch: [],
            },
            selectedReport: null,
            detailRating: 0,
            detailComment: '',
            detailComments: [],
            activePhotoIndex: 0,
            isSavingRating: false,
            isSubmittingComment: false,
        }
    },


    watch: {
        'filters.ProviderReport': {
            handler() {
                this.getFiltersFromAPI()
            },
            deep: true,
        }
    },

    computed: {
        getQuery() {
            const filters = this.getFilters()

            return Object.entries(filters)
                .filter(([_, value]) => {
                    if (Array.isArray(value)) {
                        return value.length > 0
                    }
                    return value !== null && value !== undefined && value !== ''
                })
                .map(([key, value]) => {
                    const normalizedKey = key === 'product' ? 'products' : key
                    const normalizedValue = Array.isArray(value) ? value.join(',') : value

                    return `search2[${normalizedKey}]=${encodeURIComponent(normalizedValue)}`
                })
                .join('&')
        },

        hasPhotos() {
            const report = this.selectedReport
            return !!(report && Array.isArray(report.photos) && report.photos.length > 0)
        },

        currentPhoto() {
            if (!this.hasPhotos) {
                return null
            }

            return this.selectedReport.photos[this.activePhotoIndex] || null
        },

        formattedProducts() {
            if (!this.selectedReport) {
                return '-'
            }

            if (Array.isArray(this.selectedReport.products) && this.selectedReport.products.length) {
                return this.selectedReport.products.join(', ')
            }

            if (this.selectedReport.productsText) {
                return this.selectedReport.productsText
            }

            return '-'
        },

        observationText() {
            if (!this.selectedReport) {
                return 'Sem observações.'
            }

            return this.selectedReport.obs || this.selectedReport.description || 'Sem observações.'
        },

        ratingStars() {
            return [1, 2, 3, 4, 5]
        },

        pdfUrl() {
            if (!this.selectedReport || !this.selectedReport.reportId) {
                return null
            }

            return `/provider/report/${this.selectedReport.reportId}/pdf`
        },

        canSubmitComment() {
            if (this.isSubmittingComment) {
                return false
            }

            return this.detailComment.trim().length > 0
        },
    },

    methods: {
        reloadTable() {
            if (this.$refs.reportTable) {
                this.$refs.reportTable.reloadData()
            }
        },

        clearSearch() {
            this.clearFilters()
            this.getFiltersFromAPI()
            this.reloadTable()
        },

        openReport(row) {
            if (!row) {
                return
            }

            const normalizedPhotos = Array.isArray(row.photos) ? [...row.photos] : []
            const normalizedProducts = Array.isArray(row.products) ? [...row.products] : row.products
            const normalizedRow = {
                ...row,
                photos: normalizedPhotos,
                products: normalizedProducts,
            }

            const normalizedComments = Array.isArray(row.comments)
                ? row.comments
                    .map((comment) => {
                        if (typeof comment === 'string') {
                            return {
                                message: comment,
                                createdAt: new Date().toISOString(),
                            }
                        }

                        const message = comment && typeof comment.message === 'string'
                            ? comment.message
                            : ''

                        const createdAt = comment && (comment.created_at || comment.createdAt)
                            ? (comment.created_at || comment.createdAt)
                            : new Date().toISOString()

                        return {
                            message,
                            createdAt,
                        }
                    })
                    .filter((comment) => comment.message)
                : []

            normalizedRow.comments = normalizedComments
            this.selectedReport = normalizedRow
            const ratingValue = row && Object.prototype.hasOwnProperty.call(row, 'evaluation')
                ? row.evaluation
                : row && Object.prototype.hasOwnProperty.call(row, 'rating')
                    ? row.rating
                    : 0

            const numericRating = Number(ratingValue)
            const normalizedRating = Number.isFinite(numericRating) && numericRating > 0 ? numericRating : 0

            this.detailRating = normalizedRating
            this.selectedReport.evaluation = normalizedRating > 0 ? normalizedRating : null
            this.detailComment = ''
            this.detailComments = normalizedComments
            this.activePhotoIndex = 0

            this.$nextTick(() => {
                if (this.$refs.detailModal && typeof this.$refs.detailModal.open === 'function') {
                    this.$refs.detailModal.open()
                }
            })
        },

        closeReport() {
            if (this.$refs.detailModal && typeof this.$refs.detailModal.close === 'function') {
                this.$refs.detailModal.close()
            }
            this.selectedReport = null
            this.detailComment = ''
            this.detailComments = []
            this.detailRating = 0
            this.activePhotoIndex = 0
        },

        formatDateTime(value) {
            if (!value) {
                return ''
            }

            if (this.$filters && typeof this.$filters.formatDateTime === 'function') {
                return this.$filters.formatDateTime(value)
            }

            const date = new Date(value)

            if (Number.isNaN(date.getTime())) {
                return ''
            }

            return date.toLocaleString('pt-BR')
        },

        formatYesNo(value) {
            if (value === null || typeof value === 'undefined') {
                return '-'
            }

            return Number(value) ? 'Sim' : 'Não'
        },

        nextPhoto() {
            if (!this.hasPhotos) {
                return
            }

            const total = this.selectedReport.photos.length
            this.activePhotoIndex = (this.activePhotoIndex + 1) % total
        },

        prevPhoto() {
            if (!this.hasPhotos) {
                return
            }

            const total = this.selectedReport.photos.length
            this.activePhotoIndex = (this.activePhotoIndex - 1 + total) % total
        },

        selectPhoto(index) {
            if (!this.hasPhotos) {
                return
            }

            if (index < 0 || index >= this.selectedReport.photos.length) {
                return
            }

            this.activePhotoIndex = index
        },

        openPhotoInNewTab(url) {
            if (!url) {
                return
            }

            window.open(url, '_blank', 'noopener')
        },

        async submitComment() {
            if (!this.selectedReport || this.isSubmittingComment) {
                return
            }

            const message = this.detailComment.trim()

            if (!message) {
                return
            }

            this.isSubmittingComment = true

            try {
                const { data } = await axios.post(`/provider/report/${this.selectedReport.reportId}/comments`, {
                    message,
                    activity_id: this.selectedReport.activitiesId,
                })

                const normalizedComment = {
                    message: data?.comment?.message ?? message,
                    createdAt: data?.comment?.createdAt ?? new Date().toISOString(),
                    author: data?.comment?.author ?? null,
                }

                this.detailComments = [normalizedComment, ...this.detailComments]

                if (this.selectedReport) {
                    const existingComments = Array.isArray(this.selectedReport.comments)
                        ? this.selectedReport.comments
                        : []

                    this.selectedReport.comments = [normalizedComment, ...existingComments]
                }

                this.detailComment = ''

                if (this.$toast && typeof this.$toast.success === 'function') {
                    this.$toast.success(data?.message ?? 'Comentário enviado com sucesso.')
                }
            } catch (error) {
                const errorMessage = error?.response?.data?.message ?? 'Não foi possível enviar o comentário.'

                if (this.$toast && typeof this.$toast.error === 'function') {
                    this.$toast.error(errorMessage)
                }
            } finally {
                this.isSubmittingComment = false
            }
        },

        async setRating(value) {
            if (!this.selectedReport || this.isSavingRating) {
                return
            }

            const normalizedValue = Number(value)

            if (!Number.isInteger(normalizedValue) || normalizedValue < 1 || normalizedValue > 5) {
                return
            }

            if (normalizedValue === this.detailRating && this.selectedReport?.evaluation === this.detailRating) {
                return
            }

            const previousRating = this.detailRating
            this.detailRating = normalizedValue
            this.isSavingRating = true

            try {
                const { data } = await axios.post(`/provider/report/${this.selectedReport.reportId}/evaluation`, {
                    rating: normalizedValue,
                    activity_id: this.selectedReport.activitiesId,
                })

                const savedRating = Number(data?.rating)

                if (Number.isFinite(savedRating)) {
                    this.detailRating = savedRating
                }

                if (this.selectedReport) {
                    this.selectedReport.evaluation = this.detailRating
                }

                if (this.$toast && typeof this.$toast.success === 'function') {
                    this.$toast.success(data?.message ?? 'Avaliação registrada.')
                }
            } catch (error) {
                this.detailRating = previousRating

                const errorMessage = error?.response?.data?.message ?? 'Não foi possível salvar a avaliação.'

                if (this.$toast && typeof this.$toast.error === 'function') {
                    this.$toast.error(errorMessage)
                }
            } finally {
                this.isSavingRating = false
            }
        },

        downloadPdf() {
            if (!this.pdfUrl) {
                return
            }

            window.open(this.pdfUrl, '_blank', 'noopener')
        },
    },


    setup(props) {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent('ProviderReport', {
            market_network: [],
            market: [],
            provider: [],
            brand: [],
            product: [],
            sales_promoter: [],
            date: '',
        })

        const clearFilters = () => clearFiltersComponent('ProviderReport', {
            market_network: [],
            market: [],
            provider: [],
            brand: [],
            product: [],
            sales_promoter: [],
            date: '',
        })

        const getFilters = () => getFiltersComponent('ProviderReport')

        return {
            getFilters,
            clearFilters,
            filters: filtersStore.filters,
            colunsProviderReport,
        }
    },
}

</script>
